<script lang="ts">
	export let fill = "#fff";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 18 18">
	<g>
		<path
			d="M335.379 278.005a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm4.986 5.692-5.821 7.074a.362.362 0 0 1-.554 0l-3.6-4.371a.356.356 0 0 1 .05-.5.363.363 0 0 1 .508.047l3.316 4.032 5.544-6.736a.359.359 0 1 1 .554.457z"
			transform="translate(-326.379 -278.005)"
			style={`fill:${fill}`} />
	</g>
</svg>

<style lang="scss">
</style>
